/* eslint-disable max-len */
import { createSelector } from "@reduxjs/toolkit";
import { getIndexViewPixel } from "@sparefoot/react-commons/utils/tracking";
import { mergeUrlQueryParams } from "@sparefoot/react-commons/utils/url";

export const homePageSelector = createSelector(
	({ app }) => app.trackingUrl,
	({ app }) => app.trackingId,
	({ app }) => app.baseUrl,
	(trackingUrl, trackingId, baseUrl) => ({
		trackingPixelUrl: mergeUrlQueryParams(
			`${trackingUrl}${getIndexViewPixel()}`,
			{ a: trackingId }
		),
		meta: {
			title: "Find & Rent Self Storage Units Near You - Storage.com",
			description:
				"Storage.com is a self-storage marketplace where you can easily browse an compare all storage facilities and units in your area. Reserve online for free with no credit card required.",
			canonical: baseUrl
		}
	})
);

export default homePageSelector;
